import { useContext } from 'react';
import { ModalContext } from './Context';
import { ModalContextState } from './types';

export const useModal = (): ModalContextState => {
  const context = useContext(ModalContext);

  if (context === undefined) {
    throw Error('ModalContext must be used inside ModalProvider scope');
  }

  return context;
};
